// StaffToolsMenu.jsx — 직원 관리 ☰ 메뉴 (2026-10-26 ② 자기 회사 부서 열기)
//   사용자: "IP관리와 같이 취급해줘" — 버튼이 아니라 ☰ 항목(창). 출퇴근 관리 ☰(AttendanceMenu)와 같은 모양을 그대로 쓴다.
//   항목: 부서 설정 — 이 화면 회사의 부서만(본사 직원 관리 = 본사, 회사별 직원 관리 = 그 회사). 열쇠는 직원 관리 열쇠 그대로.
//   서버가 "이 회사 부서를 고칠 수 있다"(GET /api/admin/departments?company_code=…가 200)일 때만 항목이 생긴다 —
//   못 받으면 숨김(fail-closed). 항목이 0개면 ☰ 아이콘도 그리지 않는다(AttendanceMenu 규칙).
//   그 확인은 settings.canManage(useDepartmentSettings checkAccess) — 등록 창 '+ 새 부서 추가'와 같은 답(2026-11-03).
//   2026-11-03 합치기-2: 3.3% 부서 목록(freelancerSettings)도 — 둘 중 하나라도 고칠 수 있으면 ☰, 창 안에서 고칠 수 있는 탭만.
import React, { useState } from 'react';
import AttendanceMenu from '../attendancehub/AttendanceMenu';
import DepartmentSettingsModal from './DepartmentSettingsModal';

export default function StaffToolsMenu({ settings, freelancerSettings = null, style }) {
  const [deptOpen, setDeptOpen] = useState(false);

  const canInsured = Boolean(settings?.canManage);
  const canFreelance = Boolean(freelancerSettings?.canManage);
  if (!canInsured && !canFreelance) return null;
  const items = [{ key: 'departments', label: '부서 설정', onClick: () => setDeptOpen(true) }];
  return (
    <>
      <div style={style}><AttendanceMenu items={items} /></div>
      <DepartmentSettingsModal
        open={deptOpen}
        onClose={() => setDeptOpen(false)}
        settings={canInsured ? settings : null}
        freelancerSettings={canFreelance ? freelancerSettings : null}
      />
    </>
  );
}
